export default ['1.36',

  '1.35',

  '1.34'];
